<div class="container">
    <nav aria-label="breadcrumb" class="breadCust">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a routerLink="/corporate/home">Home</a></li>
            <li class="breadcrumb-item"><a routerLink="/corporate/contentbuilder">Content Builder</a></li>
            <li class="breadcrumb-item"><a routerLink="/corporate/cb-journey">Content Builder Journey</a></li>
            <li class="breadcrumb-item active" aria-current="page">Add Content Builder Journey</li>

        </ol>
    </nav>
</div>

<div class="container">
    <form class="form-horizontal mt-1" [formGroup]="templateForm">
        <div class="row">
            <div class="col-md-10 col-xl-7">
    
              <div class="card mt-1">
    
                <div class="card-body">
                <div class="form-group">
                    <label for="exampleForm2">Select Company Name<span style="color:red">*</span></label>
                    <select formControlName="company" *ngIf="headers == 'Add'"  class="form-control formstyle"
                        [ngClass]="{ 'is-invalid': submitted && f.company.errors }" (change)="getCompanyJourney($event.target.value)">
                        <option value="">Select Company Name</option>
                        <option *ngFor="let userObj of getCompanyobj" value={{userObj.customer_id}}>
                            {{userObj.customer_company_name}}
                        </option>
                    </select>
                    <select formControlName="company" *ngIf="headers == 'Edit'" disabled="controlEnabled" class="form-control formstyle"
                    [ngClass]="{ 'is-invalid': submitted && f.company.errors }" (change)="getCompanyJourney($event.target.value)">
                    <option value="">Select Company Name</option>
                    <option *ngFor="let userObj of getCompanyobj" value={{userObj.customer_id}}>
                        {{userObj.customer_company_name}}
                    </option>
                </select>
                    <div *ngIf="submitted && f.company.errors" class="invalid-feedback">
                        <div *ngIf="f.company.errors.required">Company Name is required</div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="exampleForm2">Journey Type <span style="color:red">*</span></label>
                
                    <select formControlName="journey_type_id" name="journey_type_id" class="form-control formstyle"
                        [ngClass]="{ 'is-invalid': submitted && f.journey_type_id.errors }">
                        <option value="">------Select Journey Type------</option>
                        <option *ngFor="let item of journeyTypeObj" value={{item.journey_id}}>
                            {{item.journey_name}}
                        </option>
                    </select>
                    <div *ngIf="submitted && f.journey_type_id.errors" class="invalid-feedback">
                        <div *ngIf="f.journey_type_id.errors.required">Journey Type is required</div>
                    </div>
                </div>
                
                <div class="form-group">
                    <label for="exampleForm2">Master Journey Type <span style="color:red">*</span></label>
                
                    <select formControlName="master_journey_type_id" name="master_journey_type_id" class="form-control formstyle"
                        [ngClass]="{ 'is-invalid': submitted && f.master_journey_type_id.errors }">
                        <option value="">------Select Master Journey------</option>
                        <option *ngFor="let item of masterjourney" value={{item.id}}>
                            {{item.name}}
                        </option>
                    </select>
                    <div *ngIf="submitted && f.master_journey_type_id.errors" class="invalid-feedback">
                        <div *ngIf="f.master_journey_type_id.errors.required">Journey is required</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="exampleForm2">Journey Name <span style="color:red">*</span></label>
                    <input type="text" formControlName="journey_name" min="1" maxlength="199" class="form-control form-control-md"
                        [ngClass]="{ 'is-invalid': submitted && f.journey_name.errors }" required appSpace>
                    <div *ngIf="submitted && f.journey_name.errors" class="invalid-feedback">
                        <div *ngIf="f.journey_name.errors.required">Journey Name is required</div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="exampleForm2">Journey Description</label>
                    <textarea  class="form-control" min="1" maxlength="199" formControlName="journey_description" appSpace></textarea>
            
                    
                </div>         



                
                
            </div>

            <div class="card-footer text-center">
                <div class="my_class text-center" [ngClass]="status ? 'displayblock' : 'displaynone'">
                    <button type="submit" class="custbtn" *ngIf="isWrite" (click)="addJourney()">Submit</button>
                </div>
                <div class="my_class text-center" [ngClass]="status ? 'displaynone' :'displayblock' ">
                    <button type="button" class="custbtn" *ngIf="isEdit" (click)="updateJourney()">Update</button>
                </div>
              </div>
        </div>
    </div>
</div>
    </form>
</div>